import { MenuItem } from './menu.model';
import settings from '../../../assets/settings/system.settings.json'

export const MENU: MenuItem[] = [
    {
        id: 24,
        label: 'Landing Page',
        isTitle: true,
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Dashboard, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Crop, action: settings.RolesAccess.Action.View },
        ],
    },
    {
        id: 23,
        label: 'Landing Page',
        icon: 'bx-home-circle',
        link: '/landingpage',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Dashboard, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Crop, action: settings.RolesAccess.Action.View },
        ]
    },
    {
        id: 1,
        label: 'Application',
        isTitle: true,
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Dashboard, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Crop, action: settings.RolesAccess.Action.View },

        ],
    },
    {
        id: 30,
        label: 'User Guide',
        icon: 'bx-home-circle',
        link: '',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Dashboard, action: settings.RolesAccess.Action.View },
        ],
        subItems: [
           /* {
                id: 32,
                label: 'Upload',
                icon: 'bx-home-circle',
                link: '/upload',
                parentId: 30,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Dashboard, action: settings.RolesAccess.Action.View },
                ],
            },*/
            {
                id: 31,
                label: 'Download',
                icon: 'bx-home-circle',
                link: '/download',
                parentId: 30,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Dashboard, action: settings.RolesAccess.Action.View },
                ],
            }
          
        ]
    },
    {
        id: 2,
        label: 'Dashboards',
        icon: 'bx-home-circle',
        link: '',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Dashboard, action: settings.RolesAccess.Action.View },
        ],
        subItems: [
            {
                id: 21,
                label: 'Dashboard Estate',
                icon: 'bx-home-circle',
                link: '/dashboard',
                parentId: 2,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.EstateDashboard, action: settings.RolesAccess.Action.View },
                ]
            },

            {
                id: 22,
                label: 'Dashboard Mill',
                icon: 'bx-home-circle',
                link: '/milldashboard',
                parentId: 2,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.MillDashboard, action: settings.RolesAccess.Action.View },
                ]
            }

        ]
    },
    {
        id: 4,
        label: 'Crop',
        isTitle: true,
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Crop, action: settings.RolesAccess.Action.View },
        ]
    },
    {
        id: 16,
        label: 'Crop',
        link: '/crop/',
        icon: 'bx bx-building-house',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Crop, action: settings.RolesAccess.Action.View },
        ],
        subItems: [
            {
                id: 17,
                label: 'Estate Daily Crop',
                link: '/cropdailyestate',
                parentId: 16,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.EstateDailyCrop, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 18,
                label: 'Mill Daily Crop',
                link: '/cropdailymill',
                parentId: 16,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.MillDailyCrop, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 20,
                label: 'Estate Crop Budget & Forecast ',
                link: '/cropestatebudget',
                parentId: 16,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.EstateCropBudget, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 24,
                label: 'Mill Budget',
                link: '/millbudget',
                parentId: 16,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.MillDailyCrop, action: settings.RolesAccess.Action.View },
                ]
            },/*
            {
                id: 19,
                label: 'Estate Production Monthly Forecast',
                link: '/cropmonthlyforecast',
                parentId: 16,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.EstateProductionMonthlyForecast, action: settings.RolesAccess.Action.View },
                ]
            },*/
            {
                id: 21,
                label: 'Hectare Budget & Actual',
                link: '/hectaremonthlyforecast',
                parentId: 16,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.HectareBudgetActual, action: settings.RolesAccess.Action.View },
                ]
            }

        ]
    },
    {
        id: 4,
        label: 'Users',
        isTitle: true,
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.User, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.ProjectAction, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Roles, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Company, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Project, action: settings.RolesAccess.Action.View },
        ],
    },
    {
        id: 5,
        label: 'Users',
        icon: 'bx-home-circle',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.User, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.ProjectAction, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Roles, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Company, action: settings.RolesAccess.Action.View },
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Project, action: settings.RolesAccess.Action.View },
        ],
        subItems: [
            {
                id: 6,
                label: 'Users',
                link: '/users',
                parentId: 7,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.User, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 7,
                label: 'Project Action',
                link: '/projectaction',
                parentId: 7,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.ProjectAction, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 7,
                label: 'Roles',
                link: '/roles',
                parentId: 7,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Roles, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 9,
                label: 'Company',
                link: '/company/',
                parentId: 8,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Company, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 9,
                label: 'Projects',
                link: '/Projects/',
                parentId: 8,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Project, action: settings.RolesAccess.Action.View },
                ]
            }
        ]
    }, {
        id: 4,
        label: 'Master Data',
        isTitle: true,
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
        ]
    },
    {
        id: 12,
        label: 'Master',
        link: '/master/',
        icon: 'bx bx-building-house',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
        ],
        subItems: [
            {
                id: 18,
                label: 'Business Unit',
                link: '/businessunitlist',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 20,
                label: 'Company',
                link: '/companymaster',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 19,
                label: 'Operating Unit',
                link: '/estatemill',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 16,
                label: 'Operating Unit Type',
                link: '/estatemilltype',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 17,
                label: 'Region',
                link: '/regionlist',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 18,
                label: 'Public Holiday',
                link: '/publicholiday',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 26,
                label: 'Day/Product Type',
                link: '',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ],
                subItems: [
                    {
                        id: 25,
                        label: 'Day Type',
                        link: '/daytype',
                        parentId: 27,
                        roleAccess: [
                            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                        ]
                    },
                    {
                        id: 25,
                        label: 'Product Type',
                        link: '/producttype',
                        parentId: 26,
                        roleAccess: [
                            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                        ]
                    },
                ]
            },
            {
                id: 20,
                label: 'Tank Type',
                link: '/tanktype',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 21,
                label: 'Tank',
                link: '/tank',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 22,
                label: 'Scheduler Task',
                link: '/schedulertask',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 22,
                label: 'Mill Add Field',
                link: '/milladdfield',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
                ]
            }
            // {
            //     id: 23,
            //     label: 'Upload',
            //     link: '/upload',
            //     parentId: 12,
            //     roleAccess: [
            //         { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Master, action: settings.RolesAccess.Action.View },
            //     ]
            // }
        ]
    }, {
        id: 12,
        label: 'Log',
        icon: 'bx bx-building-house',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Log, action: settings.RolesAccess.Action.View },
        ],
        subItems: [
            {
                id: 18,
                label: 'Log',
                link: '/log',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Log, action: settings.RolesAccess.Action.View },
                ]
            }]
            
    }, 
    {
        id: 13,
        label: 'Report',
        isTitle: true,
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Report, action: settings.RolesAccess.Action.View }
        ],
    },
    {
        id: 14,
        label: 'Report',
        icon: 'bx bx-bar-chart-square',
        roleAccess: [
            { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.Report, action: settings.RolesAccess.Action.View },
        ],
        subItems: [
            {
                id: 18,
                label: 'Estate Daily Crop',
                link: '/reporting/report',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.ReportEstateDailyCrop, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 28,
                label: 'Mass Balance',
                link: '/reporting/MassBalance',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.ReportMassBalance, action: settings.RolesAccess.Action.View },
                ]
            },
            {
                id: 29,
                label: 'Mill Performance',
                link: '/reporting/MillPerformance',
                parentId: 12,
                roleAccess: [
                    { project: settings.RolesAccess.Project.Boustead_PAD, module: settings.RolesAccess.Module.ReportMillPerformance, action: settings.RolesAccess.Action.View },
                ]
            }
        ]
            
    }
];




